export default __webpack_public_path__ + "static/media/pushpin.2050d8fa.svg";